import { api } from './client';

export const getSession = async () => {
    const result = await api.get(`/session`);
    return result.data;
}

